<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <ul class="nav nav-tabs" style="margin-bottom: 10px;">
              <li role="presentation" :class="{'active': storeMethod == 1}" @click="storeMethod = 1">
                <a>基本資訊</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 2}" @click="storeMethod = 2">
                <a>細部設定</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 3}" @click="storeMethod = 3">
                <a>預訂/訂購時間</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 4}" @click="storeMethod = 4">
                <a>付款方式</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 5}" @click="storeMethod = 5">
                <a>製作/取餐時間</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 6}" @click="storeMethod = 6">
                <a>取餐方式/門檻</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 7}" @click="storeMethod = 7">
                <a>營業/公休時間</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 8}" @click="storeMethod = 8">
                <a>塑膠袋</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 10}" @click="storeMethod = 10" v-if="getRoleType === 99">
                <a>出單機</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 98}" @click="storeMethod = 98">
                <a>排除商品</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 99}" @click="storeMethod = 99">
                <a>連線紀錄</a>
              </li>
              <li role="presentation" :class="{'active': storeMethod == 15}" @click="storeMethod = 15">
                <a>特殊需求</a>
              </li>
            </ul>
          </div>
          <!--
          <div class="box-header">
            <div class="text-right" v-if="getRoleType !== 50">
              <router-link :to="{path: '/upStore/' + storeInfo.brand_id + '/' + storeInfo.id}"><button class="btn btn-primary inherit"><i class="fa fa-pencil" aria-hidden="true"></i></button></router-link>
              <br />
            </div>
          </div>
          -->
          <div class="box-body" v-if="storeMethod === 1">
            <div class="box-body m-b-10">
              <div class="text-center">
                <img :src="storeInfo.image" class="img-store-info">
                <br />
              </div>
            </div>
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">名稱 (ID)</span>
                  <div class="form-control form-info">
                    {{storeInfo.name}} ({{storeInfo.id}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">縮寫名稱</span>
                  <div class="form-control form-info">
                    {{storeInfo.name_short}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">所屬品牌 (ID)</span>
                  <div class="form-control form-info">
                    {{storeInfo.brand_name}} ({{storeInfo.brand_id}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">所屬群組 (ID)</span>
                  <div class="form-control form-info">
                    {{storeInfo.store_group_name}} ({{storeInfo.store_group_id}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  城市 (代碼)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.city_name}} ({{storeInfo.city_code}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  區域 (代碼)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.area_name}} ({{storeInfo.area_code}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  地址 (x, y)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.address}} ({{storeInfo.longitude}}, {{storeInfo.latitude}})
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  電話
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.tel}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.tel2">
                <div class="input-group">
                <span class="input-group-addon">
                  電話2
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.tel2}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.email">
                <div class="input-group">
                <span class="input-group-addon">
                  電子信箱
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.email}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.youtube_video_code">
                <div class="input-group">
                  <span class="input-group-addon">
                    Youtube影片代碼
                  </span>
                  <div class="form-control form-info">
                    {{storeInfo.youtube_video_code}}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-right">
              <div v-if="storeInfo.ein">
                <div class="input-group">
                <span class="input-group-addon">
                  統一編號
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.ein}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.bl_name">
                <div class="input-group">
                <span class="input-group-addon">
                  抬頭
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.bl_name}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.description">
                <div class="input-group">
                <span class="input-group-addon">
                  描述
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.description}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.search_description">
                <div class="input-group">
                <span class="input-group-addon">
                  描述(搜尋引擎顯示)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.search_description}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.introduction">
                <div class="input-group">
                <span class="input-group-addon">
                  門市頁介紹
                </span>
                  <div class="form-control form-info" style="white-space: pre-line" v-html="storeInfo.introduction">
                  </div>
                </div>
                <br />
              </div>
              <!--
              <div>
                <div class="input-group">
                  <span class="input-group-addon">菜單資訊背景圖</span>
                  <div class="form-control form-info">
                    <img :src="storeInfo.bg_image" class="img-responsive" style="max-width: 160px;">
                  </div>
                </div>
                <br />
              </div>
              -->
              <div v-if="storeInfo.branch_code">
                <div class="input-group">
                <span class="input-group-addon">
                  品牌下店家代碼
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.branch_code}}
                  </div>
                </div>
                <br />
              </div>
              <div  v-if="storeInfo.pos_branch_code">
                <div class="input-group">
                <span class="input-group-addon">
                  POS的店家代碼
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.pos_branch_code}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  最後更新時間
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.edit_time}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  建立時間
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.create_time}}
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.photo">
                <div class="input-group">
                <span class="input-group-addon">
                  底圖
                </span>
                  <div class="form-control form-info">
                    <img :src="storeInfo.photo" style="max-height: 100px">
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.meal_tag_info">
                <div class="input-group">
                  <span class="input-group-addon">
                    餐點種類
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success m-b-5 m-r-5" v-for="mealSetting in storeInfo.meal_tag_info">{{mealSetting.name}}</span>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 2">
            <div class="box-body form-center">
              <h3>細部設定</h3>
            </div>
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  API服務類型
                </span>
                  <div class="form-control form-info">
                    <span v-if="storeInfo.api_type === 1">專屬客製POS</span>
                    <span v-if="storeInfo.api_type === 2">公版POS</span>
                    <span v-if="storeInfo.api_type === 3">平板接單</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  門市類型
                </span>
                  <div class="form-control form-info">
                    <span v-if="storeInfo.store_type === 0">未分類</span>
                    <span v-if="storeInfo.store_type === 1">直營</span>
                    <span v-if="storeInfo.store_type === 2">加盟</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  距離計算模式
                </span>
                  <div class="form-control form-info">
                    <span v-if="storeInfo.distance_service_model === 11">走路模式(WALKING)</span>
                    <span v-if="storeInfo.distance_service_model === 12">開車模式(DRIVING)</span>
                    <span v-if="storeInfo.distance_service_model === 13">機車(SCOOTER)</span>
                    <span v-if="storeInfo.distance_service_model === 14">大眾運輸(TRANSIT)</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  營業狀態
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.status === 2">{{getStateName(storeInfo.status)}}</span>
                    <span class="label label-danger" v-else>{{getStateName(storeInfo.status)}}</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  條碼類型
                </span>
                  <div class="form-control form-info">
                    {{barcodeTypeName(storeInfo.barcode_type)}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  金額進位
                </span>
                  <div class="form-control form-info">
                    {{ roundTypeName(storeInfo.rounding_type) }}
                  </div>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-right">
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  優惠券形式
                </span>
                  <div class="form-control form-info">
                    {{couponFormName(storeInfo.coupon_form)}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    開放紙本發票
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.has_invoice_paper">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.has_invoice_paper">停用</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    開放電子載具
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.has_invoice_carrier">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.has_invoice_carrier">停用</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    發票備註
                  </span>
                  <div class="form-control form-info">
                    {{ storeInfo.invoice_remark }}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    開放愛心捐贈發票
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.has_invoice_npoban">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.has_invoice_npoban">停用</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    店家是否開發票
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="!storeInfo.is_invoice_exception">開發票</span>
                    <span class="label label-danger" v-if="storeInfo.is_invoice_exception">免開發票</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  前端顯示
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_visible">顯示</span>
                    <span class="label label-danger" v-if="!storeInfo.is_visible">未顯示</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  首頁是否搜尋的到店家
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_search">可搜尋</span>
                    <span class="label label-danger" v-if="!storeInfo.is_search">不可搜尋</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  支援客製餐點貼紙
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_support_custom_sticker">支援</span>
                    <span class="label label-danger" v-if="!storeInfo.is_support_custom_sticker">不支援</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  單品備註
                </span>
                  <div class="form-control form-info">
                    <span :class="['label',storeInfo.is_support_custom_remark?'label-success':'label-danger']">
                      {{storeInfo.is_support_custom_remark?'啟用':'停用'}}
                    </span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span
                    class="input-group-addon"
                    v-text="'單品備註'"
                  />
                  <div
                    class="form-control form-info"
                    v-text="storeInfo.custom_sticker_max_length"
                  />
                </div>
                <br />
              </div>
            </div>
            <div class="box-body  form-center">
              <h3>門市下訂金額限制</h3>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  單筆最高上限
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.one_order_max_money}} 元
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  到店付款(現金)單筆訂單最高上限
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.to_store_pay_max_money}} 元
                  </div>
                </div>
                <br />
              </div>
              <h3>菜單呈現設定</h3>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  菜單版型
                </span>
                  <div
                    class="form-control form-info"
                    v-text="menuLayout(storeInfo.menu_layout_type)"
                  />
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  飲料溫度顯示(冷 熱 無溫度)
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="!storeInfo.show_menu_icon">全部顯示</span>
                    <span class="label label-success" v-else-if="storeInfo.show_menu_icon === 1">無溫度顯示冷</span>
                    <span class="label label-danger" v-else-if="storeInfo.show_menu_icon === 2">皆顯示無溫度</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  菜單產品圖示顯示
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.show_menu_product_icon">顯示</span>
                    <span class="label label-danger" v-else="!storeInfo.show_menu_product_icon">不顯示</span>
                  </div>
                </div>
                <br />
              </div>
              <div>

              <div class="input-group">
                <span class="input-group-addon">
                  菜單當日停賣樣式
                </span>
                  <div class="form-control form-info">
                    <span v-if="storeInfo.menu_stop_sale_today_type === 1">顯示當日停賣ICON</span>
                    <span v-else="storeInfo.menu_stop_sale_today_type	 === 2">隱藏當日停賣商品</span>
                  </div>
                </div>
                <br />

              <div class="input-group">
                <span class="input-group-addon">
                  菜單永久停賣樣式
                </span>
                  <div class="form-control form-info">
                    <span v-if="storeInfo.menu_stop_sale_type === 1">顯示永久停賣ICON</span>
                    <span v-else="storeInfo.menu_stop_sale_type === 2">隱藏永久停賣商品</span>
                  </div>
                </div>
                <br />
              </div>

              <!-- 菜單編輯權限 -->
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  菜單編輯權限
                </span>
                  <div class="form-control form-info">
                    <span class="label label-danger" v-if="storeInfo.allow_update_menu === 0">關閉</span>
                    <span class="label label-success" v-else="storeInfo.allow_update_menu === 1">開啟</span>
                  </div>
                </div>
                <br />
              </div>
              <!-- End 菜單編輯權限 -->

              <!-- 紅配綠菜單分類顯示 -->
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  銷售折扣組合(紅配綠)菜單分類顯示
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.menu_ab_block_type">開啟</span>
                    <span class="label label-danger" v-else>關閉</span>
                  </div>
                </div>
                <br />
              </div>
              <!-- End 紅配綠菜單分類顯示 -->

              <!-- 菜單同步權限 -->
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  菜單同步權限
                </span>
                  <div class="form-control form-info">
                    <span class="label label-danger" v-if="storeInfo.allow_copy_menu === 0">關閉</span>
                    <span class="label label-success" v-else="storeInfo.allow_copy_menu === 1">開啟</span>
                  </div>
                </div>
                <br />
              </div>
              <!-- End 菜單同步權限 -->
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 3">
            <div class="box-body  form-center">
              <h3>預訂設定</h3>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  開始預訂(距今日幾天，0為當日)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.order_start_day}} 天
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  結束預訂(距開始預訂幾天，0為開始預訂日)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.order_tolerance_day	}} 天
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                   自動拒絕預約單時間
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.auto_reject_order_reserve_m}} 分
                  </div>
                </div>
                <br />
              </div>
              <h3>接單/送單設定</h3>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  接單狀態
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.order_status == 10">{{orderStatusName(storeInfo.order_status)}}</span>
                    <span class="label label-danger" v-if="storeInfo.order_status == 20">{{orderStatusName(storeInfo.order_status)}}</span>
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.order_status_reason">
                <div class="input-group">
                  <span class="input-group-addon">
                    暫停接單理由
                  </span>
                  <div class="form-control form-info">
                    {{storeInfo.order_status_reason}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  系統設定接單狀態
                </span>
                  <div class="form-control form-info">
                    <span class="label label-default" v-if="storeInfo.system_order_status == 0">{{orderStatusName(storeInfo.system_order_status)}}</span>
                    <span class="label label-success" v-if="storeInfo.system_order_status == 10">{{orderStatusName(storeInfo.system_order_status)}}</span>
                    <span class="label label-danger" v-if="storeInfo.system_order_status == 20">{{orderStatusName(storeInfo.system_order_status)}}</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  觸發系統自動設定的原因
                </span>
                  <div class="form-control form-info">
                    {{systemReasonName}}
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  自動拒絕接單
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.auto_reject_order_m}} 分
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  當日訂購時間前下單
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_preparing_allow_order === 1">可下單</span>
                    <span class="label label-danger" v-else>不可下單</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  結束訂購時間後下單
                </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_close_allow_order === 1">可下單</span>
                    <span class="label label-danger" v-else>不可下單</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  距營業方開始可以訂購時間
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.order_start_time_m}} 分
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                  距營業結束方可最後訂購時間
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.order_end_time_m}} 分
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 4">
            <div class="box-body form-center">
              <div><h3>付款方式</h3></div>
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">付款類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">支援</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                      <th v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10" colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">金流帳戶統一編號</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(pay, index) in storeInfo.trade_info" v-if="pay.is_valid">
                      <td>
                        {{pay.name}}
                      </td>
                      <td>
                        <span v-if="pay.is_support" class="label label-success">支援</span>
                        <span v-if="!pay.is_support"  class="label label-danger">不支援</span>
                        <span v-if="pay.use_key" class="label label-success">已設定</span>
                      </td>
                      <td>
                        <span v-if="pay.is_enable" class="label label-success">使用</span>
                        <span v-if="!pay.is_enable"  class="label label-danger">不使用</span>
                        <span v-if="pay.use_key" class="label label-success">已設定</span>
                      </td>
                      <td v-if="getRoleType === 99 || getRoleType === 30 || getRoleType === 10">{{ pay.ein }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div><h3>現金付款設定</h3></div>
              <div>
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>取餐方式</td>
                    <td>付款順序</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>內用-桌邊掃碼</td>
                    <td>{{ storeInfo.delivery_way_custom_config[21].is_cash_pay_after_meal | payAfterMeal }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="exceptionTradeList.length"><h3>付款方式與取餐金額</h3></div>
              <div v-if="exceptionTradeList.length">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>條件</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(exceptionTrade, eIndex) in exceptionTradeList">
                    <td>
                      {{exceptionTrade.delivery_type | deliveryName}}
                      <span v-if="exceptionTrade.start_money">
                        {{exceptionTrade.start_money}} 元以上
                      </span>
                      <span v-if="exceptionTrade.start_money && exceptionTrade.end_money">
                        ～
                      </span>
                      <span v-if="exceptionTrade.end_money">
                        {{exceptionTrade.end_money}} 元以下
                      </span>
                      不可用{{ exceptionTrade.trade_type | tradeName }}付款
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 5">
            <div class="box-body form-center">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">取餐類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">所需準備時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">取餐間隔</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="!hidePickupType.includes(take.take_type)"
                        class="even"
                        role="row"
                        v-for="(take, index) in storeInfo.take_time_info"
                        :key="index"
                      >
                        <td>
                          {{getDeliveryName(take.take_type)}}
                        </td>
                        <td>{{take.prepare_time_seg}} 分</td>
                        <td>{{take.take_time_seg}} 分</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="box-body form-center">
              <div class="m-t-10 process-time-block" v-for="(process, pIndex) in storeInfo.process_time_info">
                <div>
                  <div class="input-group">
                  <span class="input-group-addon">
                    時間
                  </span>
                    <div class="form-control form-info">
                      {{process.month}} 月&nbsp;&nbsp;
                      <span v-if="getTimeValue(process.start_value, process.value_type) && getTimeValue(process.end_value, process.value_type)">
                        {{getTimeValue(process.start_value, process.value_type)}} ~ {{getTimeValue(process.end_value, process.value_type)}}
                      </span>
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      取餐類型
                    </span>
                    <div class="form-control form-info">
                      {{getDeliveryName(process.delivery_type)}}
                    </div>
                  </div>
                  <br />
                </div>
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>開始時間</td>
                    <td>結束時間</td>
                    <td>準備時間</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, iIndex) in process.item_list">
                    <td>
                      {{item.start_time}}
                    </td>
                    <td>
                      {{item.end_time}}
                    </td>
                    <td>
                      {{item.process_time}} 分
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 6">
            <div class="box-body form-center">
              <div><h3>取餐方式/門檻</h3></div>
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">外送類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">支援</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">開啟</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">預設</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">店家取餐ID</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">最低消費門檻</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">距離門檻</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">送餐方式</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">訪客下單	</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">備註</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">取餐提醒</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(delivery, index) in storeInfo.delivery_info">
                      <td>{{getDeliveryName(delivery.delivery_type)}}</td>
                      <td>
                        <span v-if="delivery.is_support" class="label label-success">支援</span>
                        <span v-if="!delivery.is_support"  class="label label-danger">不支援</span>
                      </td>
                      <td>
                        <span v-if="delivery.is_enable" class="label label-success">開啟</span>
                        <span v-if="!delivery.is_enable"  class="label label-danger">關閉</span>
                      </td>
                      <td>{{delivery.is_default ? 'V' : ''}}</td>
                      <td>{{delivery.id}}</td>
                      <td>{{delivery.order_min_price}}</td>
                      <td>{{delivery.order_min_distance_m}}
                        <span v-if="delivery.delivery_type !== 3">(最低)</span>
                        <span v-if="delivery.delivery_type === 3">(最高)</span>
                      </td>
                      <td>
                        <span v-if="delivery.delivery_type === 21 && ( storeInfo.delivery_way_custom_config || subDeliveryType)">
                          {{ storeInfo.delivery_way_custom_config[21].sub_delivery_type | subDeliveryType}}
                        </span>
                      </td>
                      <td>
                        <span v-if="delivery.is_allow_guest_order" class="label label-success">開啟</span>
                        <span v-if="!delivery.is_allow_guest_order" class="label label-danger">關閉</span>
                      </td>
                      <td>{{showMemo(delivery.delivery_type, 'memo')}}</td>
                      <td>{{showMemo(delivery.delivery_type, 'pickup_memo')}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <div class="input-group">
                <span class="input-group-addon">
                   外送最大距離 (單位: 公里)
                </span>
                  <div class="form-control form-info">
                    {{storeInfo.max_delivery_distance_m | km}}
                    <span v-if="!storeInfo.max_delivery_distance_m">無限制</span>
                  </div>
                </div>
                <br />
              </div>
              <br>
              
              <div><h3>外送門檻排除指定商品</h3></div>
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">商品名稱</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">商品料號</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                      
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(item, index) in storeInfo.delivery_exception_product_info">
                      <td>{{item.product_type === 3? '套餐':'商品'}}</td>
                      <td>{{item.product_name}}</td>
                      <td>{{item.vendor_custom_id}}</td>      
                      <td>
                        <span v-if="item.is_enabled" class="label label-success">開啟</span>
                        <span v-if="!item.is_enabled"  class="label label-danger">關閉</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br />
              <div><h3>運費設定</h3></div>
              <div  v-if="shippingInfo.is_support && shippingInfo.is_enable">
                <div v-if="storeInfo.shipping_description">
                  <div class="input-group">
                    <span class="input-group-addon">運費說明</span>
                    <div class="form-control form-info">
                      {{storeInfo.shipping_description}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">運費計算</span>
                    <div class="form-control form-info">
                      <span class="label label-danger" v-if="storeInfo.shipping_fee_type == 0">不計算運費</span>
                      <span class="label label-success" v-if="storeInfo.shipping_fee_type == 1">依訂單金額計算</span>
                      <span class="label label-success" v-if="storeInfo.shipping_fee_type == 2">依運送距離計算</span>
                      <span class="label label-success" v-if="storeInfo.shipping_fee_type == 3">依運送距離+訂單金額計算</span>
                    </div>
                  </div>
                  <br />
                </div>
                <div v-if="storeInfo.shipping_fee_normal_info.vendor_custom_id">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>
                      POS廠商ID
                    </span>
                    <div class="form-control form-info">
                      {{storeInfo.shipping_fee_normal_info.vendor_custom_id}}
                    </div>
                  </div>
                  <br />
                </div>
                <!-- 依訂單金額計算 -->
                <table class="table table-bordered table-striped dataTable" v-if="storeInfo.shipping_fee_type === 1">
                  <thead class="bg-primary">
                    <tr>
                      <td>訂單金額</td>
                      <td>運費設定</td>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, iIndex) in showItemList" v-if="item.money && item.money !== null">
                    <td>
                      $ {{iIndex ? showItemList[iIndex - 1].money + 1 : 0}} ～ $ {{item.money}}
                    </td>
                    <td>
                      <span v-if="item.fee">運費 $ {{item.fee}}</span>
                      <span v-else class="text-danger">免運</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span v-if="!showItemList.length || !showItemList[showItemList.length - 2] || !showItemList[showItemList.length - 2].money">不限金額</span>
                      <span v-else>$ {{showItemList[showItemList.length - 2].money + 1}} 以上</span>
                    </td>
                    <td>
                      <span v-if="getShippingMaxFee">運費 $ {{getShippingMaxFee}}</span>
                      <span v-else class="text-danger">免運</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- End 依訂單金額計算 -->

                <!-- 依運送距離計算 -->
                <table class="table table-bordered table-striped dataTable" v-if="storeInfo.shipping_fee_type === 2">
                  <thead class="bg-primary">
                  <tr>
                    <td>運送距離</td>
                    <td>運費設定</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, iIndex) in showItemList">
                    <td>
                      <template v-if="showItemList.length <= 1 && item.distance === null">
                        不限距離
                      </template>
                      <template v-else-if="showItemList.length > 1 && item.distance === null">
                        <!-- 依需求每個層級落差為 100 公尺 -->
                        {{ numeral(showItemList[iIndex - 1].distance).add(100).value() | km}} 公里以上
                      </template>
                      <template v-else>
                        {{(showItemList[iIndex - 1] ? numeral(showItemList[iIndex - 1].distance).add(100).value() : 0) | km}} 公里 ～ {{item.distance | km}} 公里
                      </template>
                    </td>
                    <td>
                      <span v-if="item.fee">運費 ${{item.fee}}</span>
                      <span v-else class="text-danger">免運</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- End 依運送距離計算 -->

                <!-- 運送距離+訂單金額計算 -->
                <table class="table table-bordered table-striped dataTable delivery-table" v-if="storeInfo.shipping_fee_type === 3">
                  <thead class="bg-primary">
                  <tr>
                    <td>運送距離</td>
                    <td>訂單金額</td>
                    <td>運費設定</td>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in showItemList">
                      <tr :class="index%2?'even':'odd'">
                        <td :rowspan="item.range.length + 1">
                          <template v-if="showItemList.length <= 1 && item.distance == null">
                            <span>
                              不限距離
                            </span>
                          </template>
                          <template v-else-if="showItemList.length > 1 && item.distance == null">
                            <!-- 依需求每個層級落差為 100 公尺 -->
                            {{ numeral(showItemList[index - 1].distance).add(100).value() | km}} 公里以上
                          </template>
                          <template v-else>
                            {{(showItemList[index - 1] ? numeral(showItemList[index - 1].distance).add(100).value() : 0) | km}} 公里 ～ {{item.distance | km}} 公里
                          </template>
                        </td>
                      </tr>

                      <tr v-for="(range, idx) in item.range" :class="index%2?'even':'odd'">
                        <td>
                          <span v-if="idx !== item.range.length - 1">$ {{idx ? item.range[idx - 1].money + 1 : 0}} ～ $ {{range.money}}</span>
                          <span v-else>$ {{item.range[idx - 1].money + 1}} 以上</span>
                        </td>
                        <td>
                          <span v-if="range.fee">運費 $ {{range.fee}}</span>
                          <span v-else class="text-danger">免運</span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <!-- End 運送距離+訂單金額計算 -->
              </div>
              <br>
              <template v-if="showTableNumber">
                <div><h3>桌號設定</h3></div>
                <div>
                  <div class="input-group">
                  <span class="input-group-addon">
                    桌號必填
                  </span>
                    <div class="form-control form-info">
                      {{storeInfo.delivery_way_custom_config[21].is_table_no_required ? '必填' : '非必填'}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                  <span class="input-group-addon">
                    桌號編輯
                  </span>
                    <div class="form-control form-info">
                      {{storeInfo.delivery_way_custom_config[21].is_table_no_editable ? '可' : '不可'}}編輯
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                  <span class="input-group-addon">
                    桌號顯示
                  </span>
                    <div class="form-control form-info">
                      {{storeInfo.delivery_way_custom_config[21].show_table_no ? '顯示' : '隱藏'}}
                    </div>
                  </div>
                  <br />
                </div>
                <br>
              </template>
              <div v-if="exceptionCalendar.length"><h3>排除設定</h3></div>
              <div class="m-t-10" v-for="(exCalendar, caIndex) in exceptionCalendar">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                    <tr>
                      <td>{{exCalendar.delivery_type | deliveryName}}</td>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, daIndex) in exCalendar.date_type">
                    <td>
                      {{item.date}}&nbsp;{{item.start_time}} ~ {{item.end_time}}&nbsp;不可{{exCalendar.delivery_type | deliveryName}}
                    </td>
                  </tr>
                  <tr v-for="(weItem, weIndex) in exCalendar.week_day">
                    <td>
                      週{{getDayName(weItem.day)}}&nbsp;{{weItem.start_time}} ~ {{weItem.end_time}}&nbsp;不可{{exCalendar.delivery_type | deliveryName}}
                    </td>
                  </tr>
                  <tr v-for="(moItem, moIndex) in exCalendar.month_day">
                    <td>
                      每月{{moItem.day}}號&nbsp;{{moItem.start_time}} ~ {{moItem.end_time}}&nbsp;不可{{exCalendar.delivery_type | deliveryName}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 7">
            <div class="box-body  form-center">
              <h3>營業時間</h3>
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">星期</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">營業時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">訂購時間</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(open, index) in storeInfo.opening_info">
                      <td>星期{{getDayName(open.week_day)}}</td>
                      <td>{{open.start_time}} ～ {{open.end_time}}</td>
                      <td>{{open.order_start_time}} ～ {{open.order_end_time}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <br>
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">指定時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">營業時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">訂購時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">備註</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(open, index) in specialOpenTime">
                      <td>
                        <span v-for="(date, index) in open.calendarList">{{date}}<span v-if="index <  open.calendarList.length - 1">、</span></span>
                      </td>
                      <td>{{open.start_time}} ～ {{open.end_time}}</td>
                      <td>{{open.order_start_time}} ～ {{open.order_end_time}}</td>
                      <td>{{ open.remark }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <h3>公休時間</h3>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    公休時間下單
                  </span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_off_allow_order === 1">可下單</span>
                    <span class="label label-danger" v-else>不可下單</span>
                  </div>
                </div>
                <br />
              </div>
              <div v-if="storeInfo.offday_info.date.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    指定日期
                  </span>
                  <div class="form-control form-info">
                    <span v-for="(offDate, odIndex) in storeInfo.offday_info.date">{{offDate}}<span v-if="odIndex < storeInfo.offday_info.date.length - 1">、</span></span>
                  </div>
                </div>
                <br />
              </div>
              <div  v-if="storeInfo.offday_info.week_day.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    每週幾
                  </span>
                  <div class="form-control form-info">
                    <span v-for="(offWeek, owIndex) in storeInfo.offday_info.week_day">{{getWeek(offWeek)}}<span v-if="owIndex < storeInfo.offday_info.week_day.length - 1">、</span></span>
                  </div>
                </div>
                <br />
              </div>
              <div  v-if="storeInfo.offday_info.month_day.length">
                <div class="input-group">
                  <span class="input-group-addon">
                    每月幾號
                  </span>
                  <div class="form-control form-info">
                    <span v-for="(offMonth, omIndex) in storeInfo.offday_info.month_day">{{offMonth}}日<span v-if="omIndex < storeInfo.offday_info.month_day.length - 1">、</span></span>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <!-- 塑膠袋 門市資訊 -->
          <div class="box-body" v-if="storeMethod === 8">
            <div class="box-body  form-center">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">塑膠袋功能</span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.plastic_option">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.plastic_option">關閉</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">塑膠袋數量可自行調整</span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.is_plastic_amount_adjustable">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.is_plastic_amount_adjustable">關閉</span>
                  </div>
                </div>
                <br/>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">塑膠袋單位</span>
                  <div class="form-control form-info">
                    {{storeInfo.plastic_unit}}個餐點 → 1個塑膠袋
                  </div>
                </div>
                <br/>
              </div>
              <div v-if="storeInfo.delivery_way_plastic_selected">
                <div class="input-group">
                  <span class="input-group-addon">預設勾選塑膠袋</span>
                  <div class="form-control form-info">
                    <span class="label label-success m-b-5 m-r-5" v-for="defaultP in storeInfo.delivery_way_plastic_selected">{{defaultP | deliveryName}}</span>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div class="box-body form-center" v-show="storeMethod === 10">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機名稱(ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定名稱(ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">辨識碼</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">出單機啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定機啟用</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="text-center" v-if="!printerStoreList.length">
                    <td colspan="7">無出單機</td>
                  </tr>
                  <tr class="even" role="row" v-for="(printer, index) in printerStoreList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      出單機{{printer.printer_id}}號 ({{printer.printer_id}})
                    </td>
                    <td>
                      {{printer.binding_name}} ({{printer.binding_id}})
                    </td>
                    <td>{{printerType(printer.printer_type)}}</td>
                    <td>{{printer.printer_identity}}</td>
                    <td>
                      <span v-if="printer.printer_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printer.printer_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                    <td>
                      <span v-if="printer.binding_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printer.binding_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <br>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 98">
            <div class="box-body form-center">
              <h3>排除商品</h3>
            </div>
            <div class="box-body  form-center">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table style="border: 0px" aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable" v-for="(value, key) in storeInfo.delivery_exception_items_info">
                    <thead  v-for="(category, cKey) in value" v-if="value.adjust.length || value.block.length || value.category.length || value.combination.length
                            || value.option.length || value.package.length || value.product.length">
                    <tr role="row" v-if="category.length">
                      <th colspan="2" rowspan="1" aria-controls="example1" tabindex="0" class="">{{parseInt(key, 10) | deliveryName}}排除</th>
                      <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">POS料號</th>
                    </tr>
                    </thead>
                    <tbody style="border: 1px solid gray" v-for="(category, cKey) in value" v-if="value.adjust.length || value.block.length || value.category.length || value.combination.length
                            || value.option.length || value.package.length || value.product.length">
                    <tr class="even" role="row" v-for="item in category">
                      <td>{{getCategoryName(cKey)}}</td>
                      <td>
                        {{item.name}} ({{item.item_id}})
                      </td>
                      <td>
                        {{item.vendor_custom_id}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 99">
            <div class="box-body  form-center">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線狀態</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(mqtt, index) in storeInfo.mqtt_info">
                      <td>
                        {{getTime(mqtt.create_time)}}
                      </td>
                      <td>
                        <span v-if="mqtt.status === 1" class="label label-success">連線</span>
                        <span v-if="mqtt.status === 2"  class="label label-danger">中斷</span>
                      </td>
                    </tr>
                    <tr v-if="!storeInfo.mqtt_info">
                      <td colspan="2">無任何連線紀錄</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body" v-if="storeMethod === 15">
            <div class="box-body form-center" v-if="storeInfo.store_special_item_setting && Array.isArray(storeInfo.store_special_item_setting) && storeInfo.store_special_item_setting.length > 0">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">自選吸管或餐具功能</span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.store_special_item_setting[0].is_show">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.store_special_item_setting[0].is_show">關閉</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">預設吸管或餐具選項</span>
                  <div class="form-control form-info">
                    <span class="label label-success" v-if="storeInfo.store_special_item_setting[0].default_value">開啟</span>
                    <span class="label label-danger" v-if="!storeInfo.store_special_item_setting[0].default_value">關閉</span>
                  </div>
                </div>
                <br />
              </div>
            </div>

            <div class="box-body form-center" v-else>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">自選吸管或餐具功能</span>
                  <div class="form-control form-info">
                    <span class="label label-success">未設定</span>
                  </div>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">預設吸管或餐具選項</span>
                  <div class="form-control form-info">
                    <span class="label label-success">未設定</span>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" id="ad-modal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
              <h4 class="modal-title" id="myModalLabel">廣告</h4>
            </div>
            <div class="modal-body">
              <div>
                <img src="https://s3-ap-northeast-1.amazonaws.com/matcher-images-beta/banner/milkshop_0502_w_002.png" class="img-responsive">
              </div>
              <br />
              <div>
                <div class="form-control form-info text-wrap" style="min-width: 224px;">
                  https://beta-matcher-testing-web.soonsource.com/#/menu/12
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
              <!--<button type="button" class="btn btn-primary">Save changes</button>-->
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" role="dialog" id="openModal">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{storeInfo.name}}營業時間</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">星期</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">營業時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">訂購時間</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(open, index) in storeInfo.opening_info">
                      <td>星期{{getDayName(open.week_day)}}</td>
                      <td>{{open.start_time}} ～ {{open.end_time}}</td>
                      <td>{{open.order_start_time}} ～ {{open.order_end_time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" role="dialog" id="deliveryModal">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{storeInfo.name}}外送門檻</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">外送類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">店家取餐ID</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">最低消費門檻</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">距離門檻</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(delivery, index) in storeInfo.delivery_info">
                      <td>{{getDeliveryName(delivery.delivery_type)}}</td>
                      <td>
                        <span v-if="delivery.is_support" class="label label-success">使用</span>
                        <span v-if="!delivery.is_support"  class="label label-danger">不使用</span>
                      </td>
                      <td>{{delivery.id}}</td>
                      <td>{{delivery.order_min_price}}</td>
                      <td>{{delivery.order_min_distance_m}}
                        <span v-if="delivery.delivery_type !== 3">(最低)</span>
                        <span v-if="delivery.delivery_type === 3">(最高)</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" role="dialog" id="payModal">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{storeInfo.name}}付款方式</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">付款類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">狀態</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">店家付款ID</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(pay, index) in storeInfo.trade_info">
                      <td>
                        {{pay.name}}
                      </td>
                      <td>
                        <span v-if="pay.is_enable" class="label label-success">使用</span>
                        <span v-if="!pay.is_enable"  class="label label-danger">不使用</span>
                      </td>
                      <td>{{pay.id}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" role="dialog" id="takeTimeModal">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{storeInfo.name}}製作/取餐時間</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">取餐類型</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">所需準備時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">取餐間隔</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(take, index) in storeInfo.take_time_info">
                      <td>
                        {{getDeliveryName(take.take_type)}}
                      </td>
                      <td>{{take.prepare_time_seg}} 分</td>
                      <td>{{take.take_time_seg}} 分</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" role="dialog" id="mqttModal">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{storeInfo.name}}今日連線紀錄</h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">時間</th>
                      <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連線狀態</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="even" role="row" v-for="(mqtt, index) in storeInfo.mqtt_info">
                      <td>
                        {{getTime(mqtt.create_time)}}
                      </td>
                      <td>
                        <span v-if="mqtt.status === 1" class="label label-success">連線</span>
                        <span v-if="mqtt.status === 2"  class="label label-danger">中斷</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import orderTableTemp from '../Order/Temp/OrderTableTemp.vue'
import moment from 'moment'
import numeral from 'numeral'
// Require needed datatables modules
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      numeral,
      tableIndex: 1,
      storeInfo: {
        is_support_custom_remark: 0,
        offday_info: {
          date: [],
          month_day: [],
          week_day: []
        },
        shipping_fee_normal_info: {
          item_list: []
        },
        delivery_exception_items_info: {
          adjust: [],
          block: [],
          category: [],
          combination: [],
          option: [],
          package: [],
          product: []
        },
        delivery_way_plastic_selected: [],
        has_invoice_paper: 0, // 開放紙本發票
        has_invoice_carrier: 0, // 開放電子載具
        invoice_remark: '', // 發票備註
        has_invoice_npoban: 0 // 開放愛心捐贈發票
      },
      storeMethod: 1,
      printerStoreList: [],
      exceptionTradeList: [],
      exceptionCalendar: [],
      hidePickupType: [4, 5], // 隱藏的取餐方式
      tableNoCustomConfig: {}, // 桌面掃碼客製設定
      specialOpenTime: [] // 特殊營業時間
    }
  },
  filters: {
    // 公尺轉公里
    km: (val) => {
      if (val === null || isNaN(val)) return '無限制'
      return numeral(val).divide(1000).value()
    },
    payAfterMeal: (val) => {
      if (!val || !val.store_value) return '無'
      switch (Number(val.store_value)) {
        case 1:
          return '餐後付款'
        case 0:
          return '餐前付款'
        default:
          return '無'
      }
    },
    subDeliveryType: (val) => {
      if (!val || !val.store_value) return '無'
      switch (Number(val.store_value)) {
        case 1:
          return '叫號取餐'
        case 2:
          return '店家送餐'
        default:
          return '無'
      }
    }
  },
  watch: {
    storeMethod () {
      this.$router.replace({
        name: 'storeInfo',
        query: {
          'store-method': this.storeMethod
        },
        params: {
          brand_id: this.$route.params.brand_id,
          store_id: this.$route.params.store_id
        }
      })
    }
  },
  created () {
    this.getStoreInfo()
  },
  mounted () {
    if (this.$route.query['store-method']) {
      this.storeMethod = Number(this.$route.query['store-method'])
    }
  },
  methods: {
    getStoreInfo () {
      var self = this
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.storeInfo = response.data.info
          var sInfo = self.storeInfo
          // exceptionTradeList
          self.exceptionTradeList = []
          if (sInfo.delivery_exception_trade_info) {
            for (var key in sInfo.delivery_exception_trade_info) {
              let value = sInfo.delivery_exception_trade_info[key]
              value.forEach(function (item) {
                var obj = item
                obj.trade_type = parseInt(key, 10)
                self.exceptionTradeList.push(obj)
              })
            }
          }
          // exceptionCalendar
          self.exceptionCalendar = []
          if (sInfo.delivery_exception_calendar_info) {
            for (var cKey in sInfo.delivery_exception_calendar_info) {
              let cValue = sInfo.delivery_exception_calendar_info[cKey]
              cValue.delivery_type = parseInt(cKey, 10)
              if (cValue.date_type.length || cValue.month_day.length || cValue.week_day.length) self.exceptionCalendar.push(cValue)
            }
          }
          // getPrinter
          if (self.getRoleType === 99) self.getPrinterStoreList()
          // specialOpenTime
          self.specialOpenTime = []
          if (sInfo.order_time_setting.length > 0) {
            self.specialOpenTime = sInfo.order_time_setting.map(setting => ({
              id: setting.id,
              start_time: setting.start_time,
              end_time: setting.end_time,
              order_start_time: setting.order_start_time,
              order_end_time: setting.order_end_time,
              remark: setting.remark,
              calendarList: setting.calendar_list.map(item => item.usage_date)
            }))
          }
        }
      })
    },
    getWeek (value) {
      switch (value) {
        case 0: return '無指定'
        case 1: return '週日'
        case 2: return '週一'
        case 3: return '週二'
        case 4: return '週三'
        case 5: return '週四'
        case 6: return '週五'
        case 7: return '週六'
        default: return '無指定'
      }
    },
    getTimeValue (value, type) {
      if (type === 2) {
        // 星期
        return this.getWeek(value)
      } else {
        // 日期
        switch (value) {
          case 0: return '無指定'
          default: return value + '日'
        }
      }
    },
    couponFormName (type) {
      if (type === 1) {
        return '依付款方式使用優惠券'
      } else if (type === 2) {
        return '依虛擬商品使用優惠券'
      }
    },
    roundTypeName (roundType) {
      if (roundType === 1) {
        return '無條件進位'
      } else if (roundType === 2) {
        return '無條件捨去'
      } else if (roundType === 3) {
        return '四捨五入'
      } else {
        return '保留小數點'
      }
    },
    barcodeTypeName (type) {
      if (type === 0) {
        return '不支援'
      } else if (type === 1) {
        return '一維條碼'
      } else if (type === 2) {
        return '二維條碼 (QRcode)'
      } else if (type === 3) {
        return '一維&二維條碼皆支援'
      }
    },
    getStateName (state) {
      if (state === 0) {
        return '尚未營業'
      } else if (state === 1) {
        return '籌備中'
      } else if (state === 2) {
        return '營業中'
      } else if (state === 3) {
        return '休息中'
      } else if (state === 9) {
        return '已歇業'
      }
    },
    menuLayout (layout) {
      if (layout === 1) {
        return '文字，選項方塊 (飲料店用)'
      } else if (layout === 11) {
        return '文字，選項方塊，配料全展開'
      } else if (layout === 2) {
        return '圖文，商品描述為點擊後'
      } else if (layout === 3) {
        return '圖文，商品描述在下方'
      } else if (layout === 4) {
        return '文字，選項條列式 (餐廳用)'
      } else if (layout === 31) {
        return '圖文，商品描述在下方，外層大圖'
      }
    },
    orderStatusName (status) {
      var s = parseInt(status, 10)
      if (s === 10) {
        return '接單中'
      } else if (s === 20) {
        return '不接單'
      } else {
        return '未設定'
      }
    },
    getDayName (day) {
      if (day === 1) {
        return '日'
      } else if (day === 2) {
        return '一'
      } else if (day === 3) {
        return '二'
      } else if (day === 4) {
        return '三'
      } else if (day === 5) {
        return '四'
      } else if (day === 6) {
        return '五'
      } else if (day === 7) {
        return '六'
      }
    },
    getDeliveryName (type) {
      if (type === 1) {
        return '自取'
      } else if (type === 2) {
        return '內用'
      } else if (type === 3) {
        return '外送'
      } else if (type === 4) {
        return '外帶'
      } else if (type === 5) {
        return '吧台'
      } else if (type === 21) {
        return '內用-桌邊掃碼'
      } else if (type === 0) {
        return '全部取餐類型'
      }
    },
    getTime (time) {
      return moment(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
    },
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    getCategoryName (category) {
      switch (category) {
        case 'adjust': return '調整分類'
        case 'block': return '選擇區'
        case 'category': return '商品分類'
        case 'combination': return '組合'
        case 'option': return '配料'
        case 'package': return '套餐'
        case 'product': return '商品'
      }
    },
    getPrinterStoreList () {
      var self = this
      var url = '/printer/storePrinterList/' + this.$route.params.store_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerStoreList = response.data.list
        }
      })
    },
    showMemo (type, memoType) {
      const deliveryMemo = this.storeInfo.delivery_memo || []
      const data = deliveryMemo.find(item => {
        return item.delivery_type === type
      })
      return data ? memoType === 'memo' ? data.memo : data.pickup_memo : ''
    }
  },
  components: {
    'order-table': orderTableTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    statusName () {
      const status = this.storeInfo.status
      if (status === 0) {
        return '尚未營業'
      } else if (status === 1) {
        return '籌備中'
      } else if (status === 2) {
        return '營業中(上架)'
      } else if (status === 3) {
        return '休息中'
      } else if (status === 9) {
        return '已歇業'
      }
    },
    systemReasonName () {
      const reason = this.storeInfo.system_order_status_reason
      if (reason === 0) {
        return 'MQTT連線已建立'
      } else if (reason === 10) {
        return 'MQTT連線已中斷'
      } else if (reason === 20) {
        return '不接單'
      }
    },
    showTableNumber () {
      // 桌邊點餐開啟才顯示桌號設定
      const table = this.storeInfo.delivery_info.find(item => {
        return item.delivery_type === 21
      })
      return table ? Number(table.is_enable) : 0
    },
    showItemList () {
      let content = []
      let last = []
      this.storeInfo.shipping_fee_normal_info.item_list.forEach((item) => {
        if (item.distance === null) {
          last.push(item)
        } else {
          content.push(item)
        }
      })
      return content.concat(last)
    },
    getShippingMaxFee () {
      return this.storeInfo.shipping_fee_normal_info.item_list.find(function (obj) { return !obj.money }).fee
    },
    shippingInfo () {
      return this.storeInfo.delivery_info ? this.storeInfo.delivery_info[2] : {}
    }
  }
}
</script>
<style type="scss" scoped>
.delivery-table tbody {
  tr {
    display: table-row !important;
    &.odd {
      background: #f9f9f9;
    }
    &.even {
      background: #fff;
    }
  }
  td[rowspan]{
    vertical-align: middle;
    border-right: 1px solid rgb(244, 244, 244);
  }
}
</style>



// WEBPACK FOOTER //
// StoreInfo.vue?2a68dc66